export const MODIFY_UPGRADE_TEXT = 'MODIFY_UPGRADE_TEXT';

export function modifyUpgradeText(upgradeText){
    return{
        type: MODIFY_UPGRADE_TEXT,
        mainState: {
            upgradeText: upgradeText
        }
    }
}